import React from "react";
import { ToFirstCapital } from "../../Utils/helpers";

const formatStatus = (s) => ToFirstCapital((s || "").replace(/_/g, " "));

const formatDateTime = (value) => {
    if (!value) return "—";
    return new Date(value).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const ViewLeadStatusHistory = ({ open, onClose, history = [] }) => {
    if (!open) return null;

    // oldest -> newest to find the previous status, then show newest first
    const entries = [...history]
        .sort((a, b) => new Date(a.changed_at) - new Date(b.changed_at))
        .map((entry, i, arr) => ({ ...entry, from: i > 0 ? arr[i - 1].status : null }))
        .reverse();

    return (
        <div className="vl-modal-overlay" onClick={onClose}>
            <div className="vl-modal" onClick={(e) => e.stopPropagation()}>
                <div className="vl-modal-header">
                    <h3 className="vl-modal-title">Status History</h3>
                    <button className="vl-modal-close" onClick={onClose} type="button" aria-label="Close">
                        &times;
                    </button>
                </div>

                <div className="vl-modal-body">
                    {entries.length === 0 ? (
                        <div className="vl-modal-empty">No history available.</div>
                    ) : (
                        <div className="vl-notes-list">
                            {entries.map((h, idx) => (
                                <div className="vl-history-entry" key={idx}>
                                    <div className="vl-history-date">{formatDateTime(h.changed_at)}</div>
                                    <div className="vl-history-change">
                                        {h.from ? (
                                            <>
                                                <span className={`vl-inline-status vl-inline-status--${h.from}`}>
                                                    {formatStatus(h.from)}
                                                </span>
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <line x1="5" y1="12" x2="19" y2="12" />
                                                    <polyline points="12 5 19 12 12 19" />
                                                </svg>
                                            </>
                                        ) : null}
                                        <span className={`vl-inline-status vl-inline-status--${h.status}`}>
                                            {formatStatus(h.status)}
                                        </span>
                                    </div>
                                    {h.remark && <p className="vl-history-remark">{h.remark}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewLeadStatusHistory;